export const PRODUCT_SKU_GALLERY = {
  GAP: 8,
  PADDING_LEFT: 20,
}

export const SKU_THUMBNAILS_ITEMS_LIMIT = 8
